import { render } from "./AntecipacaoTitulosIndex.vue?vue&type=template&id=913ef3fe&scoped=true&ts=true"
import script from "./AntecipacaoTitulosIndex.vue?vue&type=script&lang=ts"
export * from "./AntecipacaoTitulosIndex.vue?vue&type=script&lang=ts"

import "./AntecipacaoTitulosIndex.vue?vue&type=style&index=0&id=913ef3fe&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-913ef3fe"]])

export default __exports__